'use stict';

import React from 'react';

import { OnSchedUtils } from '../../../../utils';

import './AvailableTime.css'


const AvailableTime = ({ time, element, bookAppointment, deselect, deselected }) => {
  const [selected, selectTime] = React.useState(false);

  const timeClick = () => {
    selectTime(true);
    deselect(false);
  }

  React.useEffect(() => {
    if (deselected) {
      selectTime(false);
    }
  }, [deselected]);

  const bookAppointmentEvent = (e, time) => {
    e.preventDefault();
    
    // Time has been clicked
    // If completeBooking is not provided, display form
    // If completeBooking is provided, book appointment with provided info
    bookAppointment(time);
    OnSchedUtils.CustomEvents(element.id, 'clickTime', time);
  }

  return (
    <li 
        className='AvailableTimeContainer'
      >
      <div
        className={`AvailableTime${selected ? ' selected ' : ' onsched-secondary-background-color-hover '}onsched-shadow-background-color onsched-dark-color`}
        onClick={(e) => timeClick()}
      >
        {
          time.displayTime.slice(0,1) === "0"
          ? 
          time.displayTime.slice(1)
          : 
          time.displayTime
        }
      </div>
      <div
        className={`AvailableTime AvailableTimeBookBtn${selected ? ' selected ' : ' '}onsched-secondary-background-color onsched-dark-color onsched-primary-color-hover`}
        onClick={(e) => bookAppointmentEvent(e, time)}
      >
        {OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_book')}
      </div>
    </li>
  )
}

export default AvailableTime
